import type { PackageFormTripType } from '../types'

export const STAY_FLY = 'STAY:FLY'
export const STAY_FLY_DRIVE = 'STAY:FLY:DRIVE'
export const FLY_DRIVE = 'FLY:DRIVE'
export const STAY_DRIVE = 'STAY:DRIVE'

export const CHECKBOX_TEXT: Record<PackageFormTripType, string> = {
  [STAY_FLY]: 'I only need a hotel for part of my stay',
  [STAY_FLY_DRIVE]: 'I only need a hotel for part of my stay',
  [STAY_DRIVE]: 'I want to pick up my car somewhere else',
  [FLY_DRIVE]: ''
} as const

export const RADIO_OPTIONS = [
  {
    labelNode: 'Hotel + Flight',
    value: STAY_FLY,
    name: 'packagesType',
    size: '16' as const
  },
  {
    labelNode: 'Hotel + Flight + Car',
    value: STAY_FLY_DRIVE,
    name: 'packagesType',
    size: '16' as const
  },
  {
    labelNode: 'Flight + Car',
    value: FLY_DRIVE,
    name: 'packagesType',
    size: '16' as const
  },
  {
    labelNode: 'Hotel + Car',
    value: STAY_DRIVE,
    name: 'packagesType',
    size: '16' as const
  }
]
